<script>
	import { onMount, tick } from 'svelte';
	import InlineEdit from '../../../../components/inline-edit.svelte';
	import findingService from '../../v2-service.js';
	import userService from '../../../user/service.svelte.js';
	import { getDecimalPart } from '../../../vulnerability/service';
	import { format, locale } from 'svelte-i18n';
	import dayjs from 'dayjs';

	import relativeTime from 'dayjs/plugin/relativeTime';
	import localizedFormat from 'dayjs/plugin/localizedFormat';
	import 'dayjs/locale/es';
	import 'dayjs/locale/en';

	dayjs.locale($locale);
	dayjs.extend(relativeTime);
	dayjs.extend(localizedFormat);

	let {finding} = $props();

	let userCanAdd = $state(false);
	let showSelect = $state(true);
	let users = $state([]);
	let tooltipID = $state();

	let usersPromise = userService.search().then(pUsers => users = pUsers.sort((a,b) => a.email.localeCompare(b.email)));

	onMount(async ()=>{
		await tick();
		userCanAdd = await userService.can('finding', 'add');
	});

	const handleSaveFn = (input, finding, attr) => {
		showSelect = false;
		let data = {
			vulnerability_id: finding.vulnerability_id,
			asset_id: finding.asset_id,
			id: finding.id
		}
		if(attr == 'description'){
			data.description = input.detail.value;
		}
		findingService.patch(data)
			.catch(e=>{
				return false;
			})
			.then((response)=>{
				finding.description = response.description;
				finding = finding;
			})
		;
		showSelect = true;
	};

	const handleOwnerChange = async (event) => {
		let value = event.target.value;
		if(!value){
			return;
		}
		let reqData = {
			asset_id          : finding.asset_id,
			vulnerability_id  : finding.vulnerability_id,
			user_id           : value === "null" ? null : value,
			id                : finding.id
		};
		let response = await findingService.patch(reqData).catch(e=>finding = finding);
		if(!response) return;
		finding.user_id = response.user_id;
		return finding = finding;
	}

	const handleStatusChange = async(event) => {
		let value = event.target.value;
		let reqData = {
			status            : value,
			asset_id          : finding.asset_id,
			vulnerability_id  : finding.vulnerability_id,
			id                : finding.id
		};
		let response;
		reqData.id = finding.id;
		response = await findingService.patch(reqData).catch(e=>finding = finding);
		if(!response) return;
		finding.status = response.status;
		return finding = finding;
	}

	const handleCopy = async (str, tooltip) => {
		copyText(str, tooltip);
	}
	const copyText = async (str, tooltip) => {
		await tick();
		if ('clipboard' in navigator) {
			navigator.clipboard.writeText(str)
			.then(() => {
				showTooltip(tooltip);
				hideTooltip(tooltip);
			})
			.catch((err) => console.error(err.name, err.message));
		}
		else {
			let selBox = document.createElement('textarea');
			selBox.style.position = 'fixed';
			selBox.style.left = '0';
			selBox.style.top = '0';
			selBox.style.opacity = '0';
			selBox.value = str;
			document.body.appendChild(selBox);
			selBox.focus();
			selBox.select();
			// @TODO: upgrade to clipboard API
			try{
				const success = document.execCommand('copy');
			}
			catch(err){
				return false;
			}
			showTooltip(tooltip);
			document.body.removeChild(selBox);
			hideTooltip(tooltip);
		}
	}

	const hideTooltip = (tooltip) =>{
		setTimeout(()=>{
			tooltip.classList.add('trigger-opacity-cero');
			tooltip.classList.remove('trigger-opacity-one');
			setTimeout(()=>tooltip.classList.add('d-none'), 1000);
		}, 2000);
	}

	const showTooltip = (tooltip) => {
		tooltip.classList.remove('d-none');
		setTimeout(()=>{
			tooltip.classList.remove('trigger-opacity-cero');
			tooltip.classList.add('trigger-opacity-one');
		}, 1000);
	}

	// InlineEdit options
	let inlineEdit = {
		type : 'text',
		placeholder : $format("add_desc"),
		lang : {
			'edit'   : $format("buttons.edit"),
			'save'   : $format("buttons.save"),
			'cancel' : $format("buttons.cancel"),
		},
	};
</script>
<style>
	 .d-flex > * {
		flex: 1;
	}
	.flex-container-2item div:first-child {
		flex: 2;
	}
	select.form-control {
		width: auto;
		display: inline-block;
	}
	/* Estilos de la tabla de listado para alinear la visual de los badges SLA */
	.badge {
		font-size: 0.9em;
	}
</style>

<div class="card-body">
	<div class="d-flex flex-container-2item">
		<div class="mt-3">
			<div><strong>{$format("list.columns.created")}</strong></div>
			<div>
				{dayjs(finding.first_discovery_at).format("L [-] hh:mm a")}
			</div>
		</div>
		<div class="mt-3">
			<div><strong>{$format("list.columns.seen")}</strong></div>
			<div>{dayjs(finding.last_discovery_at).format("L [-] hh:mm a")}</div>
		</div>
	</div>
	<div class="d-flex flex-container-2item">
		<div>
			{#if finding.vulnerability.priority}
				<div class="mt-3"><strong>{$format("vulnerability.severity.title")}:</strong></div>
				<div>
					<div class="cvss-badge cvss-{finding.vulnerability.level}" style="--mwidth: 70px;"><span class="t-vul-priority">{finding.vulnerability.priority < 10 && getDecimalPart(finding.vulnerability.priority) != 0 ? finding.vulnerability.priority.toPrecision(2): finding.vulnerability.priority.toFixed(0)}</span></div>
				</div>
			{/if}
		</div>
		<div>
			{#if finding.confidence}
				<div class="mt-3">
					<div><strong>{$format("page.finding.confidence")}:</strong></div>
					<div>
						{finding.confidence}
					</div>
				</div>
			{/if}
		</div>
	</div>
	<div class="d-flex flex-container-2item">
		<div class="mt-3">
			<div>
				<strong>{$format("buttons.assign_finding.assign")}</strong>:
				{#if showSelect && userCanAdd}
					{#await usersPromise then users}
						<select class="form-control" value={finding.user_id} id='changeFindingOwner' name='changeFindingOwner' oninput={(e)=>handleOwnerChange(e)}>
							<option value={null}>Elegir usuario</option>
							<option value={"null"}>{$format("buttons.assign_finding.remove")}</option>
							{#each users as user}
								<option value={user.id}>{user.email}</option>
							{/each}
						</select>
					{/await}
				{/if}
			</div>
		</div>
		<div class="mt-3">
			<div>
				<strong>{$format("finding.status.title")}</strong>:
				{#if showSelect && userCanAdd}
					<select class="form-control" value={finding.status} id='changeFindingsStatus' name='changeFindingsStatus' oninput={(e)=>handleStatusChange(e)}>
						<option value='open'>{$format("finding.status.open")}</option>
						<option value='accepted'>{$format("finding.status.accepted")}</option>
						<option value='fixed'>{$format("finding.status.fixed")}</option>
						<option value='false_positive'>{$format("finding.status.false_positive")}</option>
					</select>
				{/if}
			</div>
		</div>
	</div>
	<div class="d-flex flex-container-2item">
		<div class="mt-3">
			<div>
				<strong>{$format("list.columns.description")}</strong>:
				<div><InlineEdit {...inlineEdit} value={finding.description} on:save={(e)=>handleSaveFn(e, finding, "description")} /></div>
			</div>
		</div>
		<div>
			<div class="mt-3"><strong>ID</strong>:</div>
			{#if finding.id}
				{finding.id || ''}
				<button class="btn btn-copy far fa-copy" title="Copiar al portapapeles" aria-label="Copiar" style="position: relative; top: -2px;" onclick={()=>handleCopy(finding.id, tooltipID)}></button>
					<span id="tooltip-compose" class="d-none trigger-opacity-cero copy-tooltip" bind:this={tooltipID}>{$format("copied")}</span>
			{:else}
				<div class="overlay justify-content-start">
					<i class="fas fa-sync-alt fa-spin"></i>
				</div>
			{/if}
		</div>
	</div>

	<!-- INICIO FILA SLA -->
	<div class="d-flex flex-container-2item">
		<div class="mt-3">
			<div><strong>SLA</strong>:</div>
			<div>
				{#if finding.sla_days_remaining === null || finding.sla_days_remaining === undefined || finding.sla_days_remaining === ""}
					<span class="text-muted" title={$format("finding.sla.no_sla")}>-</span>
				{:else if Number(finding.sla_days_remaining) > 0}
					<span class="badge text-bg-success px-2 py-1" title={$format("finding.sla.days_remaining")}>{finding.sla_days_remaining}</span>
				{:else}
					<span class="badge text-bg-danger px-2 py-1" title={$format("finding.sla.expired")}>{finding.sla_days_remaining}</span>
				{/if}
			</div>
		</div>
		<div></div>
	</div>
	<!-- FIN FILA SLA -->

	<div>
		<div>
			{#if finding.specific}
				<div class="mt-3"><strong>{$format("page.finding.specific")}:</strong></div>
				<div>
					{finding.specific}
				</div>
			{/if}
		</div>
		{#if finding.specific || finding.extra_text || finding.extra_data }
			<div class="mt-3"><strong>{$format("page.finding.extra_text")}:</strong></div>
			<div class="d-flex flex-column" style="gap: 7px;">
				{#if finding.extra_text }
					<div class="" style="white-space: break-spaces;">{finding.extra_text}</div>
				{/if}
				{#if finding.extra_data }
					{#each finding.extra_data as data}
						{#each Object.entries(data) as [k,v]}
							<div>{k}: {v}</div>
						{/each}
					{/each}
				{/if}
			</div>
		{/if}
	</div>
</div> <!-- /card-body -->